(function($) {
	
	const $block = $('.wp-block-metropolis-scrolling-slideshow');
	
	$block.each(function() {
		
		var $this = $(this),
			resizeTimer,
			$media = $this.children('.wp-block-columns').children('.fixed'),
			$content = $media.siblings('.content'),
			$mediaSlides = $media.children(),
			$contentSlides = $content.children(),
			length = $contentSlides.length,
			$dotsNav = $("<nav>", { class: "dots" });
					
		for (i = 0; i < length; i++) { 
			$dotsNav.append( '<span></span>' );
		}
		
		var $dots = $dotsNav.children();
		
		$dotsNav.appendTo( $media );
			
		var recalulate = function() {
			var mediaHeight = $media.height();
			$media.css( { top: 'calc(50% - ' + mediaHeight / 2 + 'px' } );
		};
		
		$contentSlides.waypoint({
			handler: function(direction) {
				var idx = jQuery(this.element).index();
				if (direction == 'up') {
					idx = (idx == 0) ? 0 : idx - 1;
				}
				$dots.removeClass('active').addClass('not-active').eq(idx).toggleClass('not-active active');
				$contentSlides.removeClass('active').addClass('not-active').eq(idx).toggleClass('not-active active');
			},
			offset: '65%',
		});
		
		$contentSlides.addClass('not-active').first().toggleClass('not-active active');
		$dots.addClass('not-active').first().toggleClass('not-active active');
		recalulate();
		
		$(window).on('resize', function(e) {
			
			clearTimeout(resizeTimer);
			
			resizeTimer = setTimeout(function() {
			
				recalulate();
						
			}, 100);
			
		});
		
	});
	
})(jQuery);